// AJAX Pagination for Shopify collections
// Works with filters and sorting (facets.js)

(function () {
  function isSegmentCollectionPagination() {
    return document.getElementById('ProductGridContainer')?.dataset.segmentPagination === 'true';
  }

  async function onPaginationClick(e) {
    const link = e.target.closest('a[href]');
    if (!link || !link.closest('.pagination__list')) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    if (isSegmentCollectionPagination() && window.CollectionSegmentPagination?.goToPage) {
      return;
    }

    e.preventDefault();
    const url = new URL(link.href, window.location.origin);
    const searchParams = url.search ? url.search.slice(1) : '';
    if (window.FacetFiltersForm && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(searchParams, null, true);
      const anchor = link.hash || '#ProductGridContainer';
      const el = document.querySelector(anchor);
      if (el) {
        const yOffset = -90;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    } else {
      window.location.href = link.href;
    }
  }

  function bindPaginationLinks() {
    document.querySelectorAll('.pagination__list a').forEach((a) => {
      a.addEventListener('click', onPaginationClick);
    });
  }

  document.addEventListener('DOMContentLoaded', bindPaginationLinks);
  document.addEventListener('pagination:updated', bindPaginationLinks);
})();
